module.exports = __webpack_public_path__ + "a56d0d5ac986549fa8875306ed8dd07c.svg";